import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=b73d3f36&"
import script from "./ExpansionPanel.ts?vue&type=script&lang=js&"
export * from "./ExpansionPanel.ts?vue&type=script&lang=js&"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=b73d3f36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports